// extracted by mini-css-extract-plugin
export var currentStep = "_i2-2";
export var nodeCard = "_i2-0";
export var pathHighlighted = "_i2-1";